import React, { useEffect, useState } from 'react'

// Gatsby
import { useStaticQuery, graphql } from "gatsby"
import { window, document } from 'browser-monads'

// Components
import Slider from './slider/slider'

// Libs 
import BeforeAfterSlider from 'react-before-after-slider'
import { isMobile } from "react-device-detect"

const BeforeAfter = () => {
  const [clients, setClients] = useState([])
  const [slider, setSlider] = useState()
  const data = useStaticQuery(graphql`
    query GetClients {
      allStrapiClient {
        nodes {
          title
          id
          after {
            childImageSharp {
              fixed(width: 300, height: 300) {
                ...GatsbyImageSharpFixed
              }
            }
          }
          before {
            childImageSharp {
              fixed(width: 300, height: 300) {
                ...GatsbyImageSharpFixed
              }
            }
          }
        }
      }
    }
  `)

  const beforeAfter = (node) => {
    const before = node.before.childImageSharp.fixed.src
    const after = node.after.childImageSharp.fixed.src
    const width = isMobile ? 300 : 600
    const height = isMobile ? 300 : 600
    return (
      <div key={node.title} >
        <h1 className="font-light">{node.title}</h1>
        <BeforeAfterSlider
          before={before}
          after={after}
          width={width}
          height={height}
        />
      </div>
    )
  }

  useEffect(() => {
    if (data && data.allStrapiClient?.nodes.length > 0) {
      setClients(data.allStrapiClient?.nodes)
    }
  }, [data])

  useEffect(() => {
    if (window && document) {
      const slides = clients.map(beforeAfter)
      setSlider(
        <div style={{ minWidth: 300 }}>
          <Slider items={slides} settings={{ slidesToShow: 1, autoplay: false, draggable: false }} />
        </div>
      )
    }
  }, [clients, window])

  return (
    <section className="grid grid-cols-12 bg-gray-200">
      <div className="col-start-2 col-span-10 lg:col-start-4 lg:col-span-6 text-center my-10">
        <h3 data-aos="fade-down" data-aos-duration="800" className="text-3xl tracking-wider mb-10">ANTES Y DESPUÉS DE CASOS EXITOSOS </h3>
        <div className="grid grid-cols-12">
          <div className="col-start-1 col-span-8 lg:col-start-2 lg:col-span-10 items-center justify-center">
            {slider ? slider : null}
          </div>
        </div>
        <p data-aos="fade-up" data-aos-duration="800" className="text-2xl my-8 font-light tracking-wide text-gray-700">Conoce nuestros tratamientos y mide sus resultados con los casos de éxito en nuestros pacientes.</p>
      </div>
    </section>
  )
}

export default BeforeAfter